import Vue from "vue";
import lodash from "lodash";
// import constants from "@/assets/constants";

export default {
  namespaced: true,
  state: {
    initialized: false,
    presets: null
  },
  mutations: {
    /**
     * Internal use, prevent double-setup ws listeners
     * @param {*} state
     * @param {*} value
     */
    setInitialized(state, value) {
      state.initialized = value;
    },
    setValue(state, { id, value }) {
      if (!state.presets) {
        state.presets = {};
      }

      Vue.set(state.presets, id, value);
    }
  },
  actions: {
    /**
     * Runs only once (when not initialized),
     * sets up all the necessary topquiz handlers to manage this store
     * @param {*} me
     * @param {*} vm
     */
    storeCreated(me, vm) {
      if (me.state.initialized === true) {
        return;
      }

      me.commit("setInitialized", true);

      vm.$topquiz.on(this, "getUserPresets_success", params => {
        var list = params[0];
        list.forEach(preset => {
          me.commit("setValue", { id: preset.preset_id, value: preset.value });
        });
      });

      vm.$topquiz.on(this, "changedPreset", params => {
        var id = params[0];
        var value = params[1];
        me.commit("setValue", { id, value });
      });
    },
    loadPresets(me, vm) {
      me.dispatch("storeCreated", vm);
      vm.$topquiz.sendCommand("getUserPresets", vm.$topquiz.SessionKey);
    },
    setValues(me, values) {
      values.forEach(preset => {
        me.commit("setValue", { id: preset.id, value: preset.value });
      });
    },
    sendValues(me, vm) {
      lodash.forEach(me.state.presets, (value, id) => {
        vm.$topquiz.sendCommand(
          "setUserPreset",
          vm.$topquiz.SessionKey,
          id,
          value
        );
      });
    }
  },
  getters: {
    getValue: state => id => {
      if (!state.presets) {
        return null;
      }

      return state.presets[id];
    }
  }
};
